import React, { FC, ReactElement } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { Alert, SelectChangeEvent, Stack } from "@mui/material";

import Header from "../../components/Header";
import Page from "../../components/Page";
import { useSelector } from "../../store";
import { useListActivityLogsQuery } from "../../store/enhancedApi";
import { EntityType } from "../../store/pomeriumApi";
import ActivityLogDiff from "./components/ActivityLogDiff";
import ActivityLogPicker from "./components/ActivityLogPicker";

const Diff: FC = (): ReactElement => {
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { organizationId } = useSelector((state) => state.current);

  const entityType = params.entityType;
  const entityId = params.entityId;

  const { data: activityLogsResult, isLoading } = useListActivityLogsQuery(
    {
      organizationId,
      entityId,
      entityType: entityType as EntityType,
    },
    {
      skip: !organizationId || !entityId,
    },
  );
  const activityLogs = activityLogsResult?.rows || [];

  if (!entityId || !entityType) {
    return <Alert severity="error">Missing parameter in the URL!</Alert>;
  }

  if (!activityLogs?.length && !isLoading) {
    return (
      <Alert severity="error">
        The requested Entity doesn't exist. It may have been deleted!
      </Alert>
    );
  }

  const toId = searchParams.get("to") || "";
  const fromId =
    searchParams.get("from") ||
    activityLogs?.find((_, index) => activityLogs?.[index - 1]?.id === toId)
      ?.id ||
    "";

  function handleChangeFromId(evt: SelectChangeEvent<string>): void {
    setSearchParams((params) => {
      params.set("from", evt.target.value);
      return params;
    });
  }
  function handleChangeToId(evt: SelectChangeEvent<string>): void {
    setSearchParams((params) => {
      params.delete("from");
      params.set("to", evt.target.value);
      return params;
    });
  }

  return (
    <Page title="Change Comparison">
      <Stack spacing={1} sx={{ height: "100%" }}>
        <Header title="Change Comparison" breadcrumbs={true} />
        <Stack direction="row" spacing={1}>
          <ActivityLogPicker
            allowEmpty={true}
            selectedId={fromId}
            activityLogs={activityLogs}
            onChange={handleChangeFromId}
          />
          <ActivityLogPicker
            allowEmpty={false}
            selectedId={toId}
            activityLogs={activityLogs}
            onChange={handleChangeToId}
          />
        </Stack>
        <ActivityLogDiff
          left={activityLogs?.find((activityLog) => activityLog.id === fromId)}
          right={activityLogs?.find((activityLog) => activityLog.id === toId)}
        />
      </Stack>
    </Page>
  );
};
export default Diff;
